/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/alt-text */
// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Link, useMediaQuery } from '@mui/material';

// project imports
import LAYOUT_CONST from 'constant';
import useConfig from 'hooks/useConfig';
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import LocalizationSection from './LocalizationSection';
import MegaMenuSection from './MegaMenuSection';
import NotificationSection from './NotificationSection';

import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

// assets
import { IconMenu2 } from '@tabler/icons';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const { layout } = useConfig();
    const [instituteLogo, setInstituteLogo] = useState('');
    const { instituteId } = useParams();
    const role = localStorage.getItem('role');
    const userType = localStorage.getItem('userTypes');
    const mbbsUser = localStorage.getItem('mbbsUser');
    const mbbsPrincipal = localStorage.getItem('mbbsPrincipal')
    const instituteID = localStorage.getItem('instituteId');

    const downloadDocumentFunction = (fileName) => {
        axios
            .post(
                `/v1/utils/file/download`,
                { fileName },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then((result) => {
                setInstituteLogo(result.data.data);
            });
    };

    const getInstituteHeader = () => {
        axios
            .get(`/v1/institutes/get?instituteId=${instituteId === undefined ? instituteID : instituteId}`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json'
                }
            })
            .then((result) => {
                if (userType !== 'EXTERNAL_CLIENT') {
                    downloadDocumentFunction(result.data.data.instituteLogo);
                } else {
                    downloadDocumentFunction(result.data.data.externalClientLogo);
                }
            });
    };

    useEffect(() => {
        getInstituteHeader();
    }, []);

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 200,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                {/* <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <img src="/assets/images/icons/ustm-logo_T.svg" width="200px" alt="" />
                </Box> */}
            </Box>
            {layout === LAYOUT_CONST.VERTICAL_LAYOUT || (layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && matchDownMd) ? (
                <>
                    <Avatar
                        variant="rounded"
                        style={{
                            backgroundColor: '#FFC700'
                        }}
                        sx={{
                            // ...theme.typography.commonAvatar,
                            // ...theme.typography.mediumAvatar,
                            overflow: 'hidden',
                            ml: 1,
                            transition: 'all .2s ease-in-out'
                            // background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                            // color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                            // '&:hover': {
                            //     background: theme.palette.mode === '#005E9F' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                            //     color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
                            // }
                        }}
                        onClick={() => dispatch(openDrawer(!drawerOpen))}
                    >
                        <IconMenu2
                            stroke={1.2}
                            style={{
                                // color:"#FFCD00",
                                color: 'black'
                            }}
                            size="20px"
                        />
                    </Avatar>
                    <Box sx={{ flexGrow: 0.1 }} />
                    <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                        {/* <img src="/assets/images/icons/USTM_inside_logo.svg" /> */}
                        {/* {userType !== 'EXTERNAL_CLIENT' ? (/ */}
                        <>
                            <img
                                src={
                                    role === 'ROLE_SUPER_ADMIN' && userType !== 'EXTERNAL_CLIENT'
                                        ? '/assets/images/icons/USTM.svg'
                                        : userType === 'HOD' &&
                                            role === 'ROLE_COLLEGE_SUB_ADMIN' &&
                                            (mbbsUser === null || mbbsUser === 'true' || mbbsUser === undefined)
                                            ? '/assets/images/icons/PimcUstm.png'

                                            : userType === 'Staff' &&
                                                role === 'ROLE_COLLEGE_SUB_ADMIN' &&
                                                (mbbsPrincipal === null || mbbsPrincipal === 'true' || mbbsPrincipal === undefined)
                                                ? '/assets/images/icons/PimcUstm.png'
                                                : instituteLogo
                                }
                            />
                        </>
                        {/* ) : (
                            <>
                                <img src={instituteLogo} />
                            </>
                        )} */}
                    </Box>
                </>
            ) : null}

            {/* <SearchSection /> */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* mega-menu */}
            {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <MegaMenuSection />
            </Box> */}

            {/* live customization & localization */}
            {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <LocalizationSection />
            </Box> */}

            {/* notification & profile */}
            <NotificationSection />
            <ProfileSection />

            {/* mobile header */}
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileSection />
            </Box>
        </>
    );
};

export default Header;
